import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { StoreStatement } from '../models/profile.model';

@Injectable()
export class DepositTransferService {
    constructor(private http: HttpClient) {
    }

    AdminCreateManualDeposit(donationId,seoName): any {
        return this.http.get(Configuration.apiUrl + 'Api/DepositTransfer/CreateManualDeposit?donationId=' + donationId + '&seoName=' + seoName + '&polenTest=true')
    }

    AdminDepositTransferPix(depositId): any {
        debugger
        console.log('Api/DepositTransfer/TransferPix?depositId=' + depositId)
        return this.http.get(Configuration.apiUrl + 'Api/DepositTransfer/TransferPix?depositId=' + depositId)
    }
}
